import axios from 'axios';

/**
 * Best-effort report of a production client-side error to the backend
 * (`client.log`). Fire-and-forget: a failed report must never itself throw,
 * since it's usually called from an error path already.
 */
export function reportClientError(error: {
  message: string;
  stack?: string;
  componentStack?: string;
}) {
  if (import.meta.env.DEV) {
    return;
  }

  axios
    .post('/api/client-error', {
      message: error.message,
      stack: error.stack,
      componentStack: error.componentStack,
      url: window.location.href,
    })
    .catch(() => undefined);
}
